<script setup lang="ts">
import { useFormContainer } from "~/composables/useFormContainer";
import FormCard from "~/components/ui/FormCard.vue";

defineProps({
  progress: { type: Number, required: true },
});

const { FormContainer } = useFormContainer();

const emit = defineEmits(["init", "submit", "decline"]);
onMounted(() => emit("init"));
</script>

<template>
    <FormContainer :progress="progress" title="CLUB PLUS">
      <FormCard
        title="CLUB PLUS"
        :header-class="'pageTitle mb-4'" 
        @submit.prevent="emit('submit')"
      >
        <p class="mb-4">
          Cofidis ti regala il primo mese di
          <strong>accesso gratuito al CLUB PLUS.</strong> Puoi scegliere
          <strong>esperienze uniche in formula 2x1</strong>
          (ad esempio cena al ristorante per 2 persone al prezzo di 1 oppure 2
          ingressi al cinema o alla SPA pagandone solo 1) a soli 9,90
          euro/mese, con addebito diretto sul tuo conto corrente.
          <a class="underline" :href="CLUB_PLUS_INFO_URL" target="_blank">Scopri qui</a>
          tutti i vantaggi del CLUB PLUS.
          <strong>Il servizio CLUB PLUS è facoltativo e non è necessario per ottenere il prestito o per ottenerlo a condizioni più vantaggiose.</strong>
        </p>
      </FormCard>

      <div class="text-center text-gray-700 mt-4 mb-8">
        <button
          data-testid="decline"
          class="underline cursor-pointer"
          @click="emit('decline')"
        >
          Procedi senza Club
        </button>
      </div>
    </FormContainer>
</template>

<style scoped></style>
